// 병원 기본 정보 (매년 문구를 직접 고치지 않도록 연도/햇수는 자동 계산)

export const SITE_URL = 'https://www.hanson-dental.co.kr';

// 개원 시점: 2019년 5월
const OPENING_YEAR = 2019;
const OPENING_MONTH = 5;

const today = new Date();

// 현재 연도 (예: "2026년 현재", 저작권 표기)
export const CURRENT_YEAR = today.getFullYear();

// 개원 후 지난 햇수 (매년 5월이 되면 1년씩 늘어남)
export const YEARS_SINCE_OPENING =
  CURRENT_YEAR - OPENING_YEAR - (today.getMonth() + 1 < OPENING_MONTH ? 1 : 0);
